import { Component, OnInit, OnDestroy, HostListener } from "@angular/core";
import { ResetPasswordService } from "src/app/shared/auth/reset-password.service";
import { LogoutService } from "src/app/shared/auth/logout.service";
import { Router } from "@angular/router";
import { CloudUserService } from "src/app/shared/user/cloud-user.service";
import { UserInfoConfigurationService } from "src/app/shared/configuration/user-info/user-info-configuration.service";
import { ConfigurationService } from "src/app/shared/configuration/configuration.service";
import { ResetPasswordConfigurationService } from "src/app/shared/configuration/auth/reset-password/reset-password-configuration.service";
import { LogoutConfigurationService } from "src/app/shared/configuration/auth/logout/logout-configuration.service";
import {
  takeWhile,
  tap,
  mergeMap,
  finalize,
  filter,
  catchError,
} from "rxjs/operators";
import { Observable, timer, EMPTY, of, throwError, from } from "rxjs";
import { CloudUser } from "src/app/shared/user/cloud-user";
import { UserInfoService } from "src/app/shared/user-info/user-info.service";
import { TabCacheService } from "src/app/shared/tabs/tab-cache.service";
import { CloudIdStorageService } from "src/app/shared/cloud/cloud-id-storage.service";
import { EmailService } from "src/app/shared/email/email.service";
import { CloudUserStorageService } from "src/app/shared/user/cloud-user-storage.service";
import { UserInfoStorageService } from "src/app/shared/user-info/user-info-storage.service";
import { TimeService } from "src/app/shared/time/time.service";
import { TabSessionStorageService } from "src/app/shared/tabs/tab-session-storage.service";
import { ErrorService } from "src/app/shared/error/error.service";
import { CloudNameStorageService } from "src/app/shared/cloud/cloud-name-storage.service";
import { ReleaseLicenseConfigurationService } from "src/app/shared/configuration/auth/logout/release-license/release-license-configuration.service";
import { ReleaseLicenseService } from "src/app/shared/license/release-license.service";
import { UserMessageService } from "src/app/service/user-message.service";
@Component({
  standalone: false,
  selector: "app-portal",
  templateUrl: "./portal.component.html",
  styleUrls: ["./portal.component.scss"],
})
export class PortalComponent implements OnInit, OnDestroy {
  licenseCheckTimeStorageKey = "license_check_time";
  userInActiveMessage: string = "";

  get cloudsUrl() {
    return this.router.parseUrl("/clouds");
  }

  get userInfoEnabled() {
    return this.userInfoConfiguration.enabled;
  }

  get userInfoConfiguration() {
    return this.userInfoConfigurationService.configuration;
  }

  get selectCloudEnabled() {
    return this.configurationService.selectCloud;
  }

  get logoutEnabled() {
    return this.logoutConfigurationService.enabled;
  }

  cloud;

  get resetPasswordConfiguration() {
    return this.resetPasswordConfigurationService.configuration;
  }

  get tabs() {
    return this.tabCacheService.tabs;
  }

  get cloudUnderMaintenance() {
    return this.appErrorService.cloudMaintenance;
  }

  get releaseLicenseEnabled() {
    return this.releaseLicenseConfiguration.enabled;
  }

  get releaseLicenseConfiguration() {
    return this.releaseLicenseConfigurationService.configuration;
  }

  alive;

  loading;

  cloudName;

  initials;

  firstName;

  lastName;

  email;

  admin;

  fullName;

  constructor(
    private resetPasswordService: ResetPasswordService,
    private logoutService: LogoutService,
    private router: Router,
    private cloudUserService: CloudUserService,
    private userInfoConfigurationService: UserInfoConfigurationService,
    private configurationService: ConfigurationService,
    private resetPasswordConfigurationService: ResetPasswordConfigurationService,
    private logoutConfigurationService: LogoutConfigurationService,
    private userInfoService: UserInfoService,
    private tabCacheService: TabCacheService,
    private cloudIdStorageService: CloudIdStorageService,
    private emailService: EmailService,
    private cloudUserStorageService: CloudUserStorageService,
    private userInfoStorageService: UserInfoStorageService,
    private timeService: TimeService,
    private tabSessionStorageService: TabSessionStorageService,
    private appErrorService: ErrorService,
    private cloudNameStorageService: CloudNameStorageService,
    private releaseLicenseConfigurationService: ReleaseLicenseConfigurationService,
    private releaseLicenseService: ReleaseLicenseService,
    private userMessageService: UserMessageService
  ) {}

  releaseLicense() {
    return this.releaseLicenseService.releaseLicense();
  }

  @HostListener("window:beforeunload")
  onBeforeUnload() {
    if (this.releaseLicenseEnabled) {
      this.releaseLicense();
    }
  }

  onCloseCloudMaintenancebanner() {
    this.appErrorService.cloudMaintenance = false;
  }

  onCloseInActiveUserbanner() {
    this.userInActiveMessage = "";
  } 

  ngOnDestroy(): void {
    this.alive = false;
  }

  workoutFullName(firstName, lastName) {
    return firstName + " " + lastName;
  }

  workoutInitials(firstName, lastName) {
    let firstNameFirstLetter;
    if (firstName.length) {
      firstNameFirstLetter = firstName[0];
    } else {
      firstNameFirstLetter = "";
    }

    let lastNameFirstLetter;
    if (lastName.length) {
      lastNameFirstLetter = this.lastName[0];
    } else {
      lastNameFirstLetter = "";
    }
    return firstNameFirstLetter + lastNameFirstLetter;
  }

  ngOnInit() {
    this.alive = true;
    this.userMessageService.currentMessage.subscribe(message => this.userInActiveMessage = message)

    if (this.userInfoEnabled) {
      this.userInfoInit().subscribe();
    } else {
      this.userInit().subscribe();
    }

    this.useLicense().subscribe();
  }

  userInfoInit() {
    this.loading = true;
    this.cloudName = this.loadCloudName();

    const cachedUserInfo = this.getCachedUserInfo();
    if (cachedUserInfo) {
      this.storeUserInfo(cachedUserInfo);
      this.fillInInfoFromUserInfo(cachedUserInfo);
      return of(cachedUserInfo);
    } else {
      return this.getUserInfo().pipe(
        tap((userInfo: any) => {
          this.storeUserInfo(userInfo);
          this.fillInInfoFromUserInfo(userInfo);
        }),
        finalize(() => {
          this.loading = false;
        })
      );
    }
  }

  storeCloudUser(cloudUser) {
    this.cloudUserStorageService.currentUser = cloudUser;
  }

  loadCloudName() {
    return this.cloudNameStorageService.loadCloudName();
  }

  userInit() {
    if (this.cloudUnderMaintenance) {
      return of(null);
    } else {
      this.loading = true;
      const cachedCloudUser = this.getCachedCloudUser();
      if (cachedCloudUser) {
        this.fillInInfoFromCloudUser(cachedCloudUser);
        return of(cachedCloudUser);
      } else if (this.cloudUnderMaintenance) {
        return of(null);
      } else {
        return this.getCloudUser().pipe(
          tap((user: CloudUser) => {
            this.fillInInfoFromCloudUser(user);
          }),
          finalize(() => {
            this.loading = false;
          })
        );
      }
    }
  }

  fillInInfoFromCloudUser(user: CloudUser) {
    this.firstName = user.Firstname;
    this.lastName = user.Lastname;
    this.admin = user.IsSystemAdministrator;
    this.email = user.Email;
    this.initials = this.workoutInitials(user.Firstname, user.Lastname);
    this.fullName = this.workoutFullName(user.Firstname, user.Lastname);
  }

  fillInInfoFromUserInfo(userInfo: any) {
    this.firstName = userInfo.given_name;
    this.lastName = userInfo.family_name;
    this.email = userInfo.email;
    this.initials = this.workoutInitials(
      userInfo.given_name,
      userInfo.family_name
    );
    this.fullName = this.workoutFullName(
      userInfo.given_name,
      userInfo.family_name
    );
  }

  storeUserInfo(userInfo) {
    return this.userInfoStorageService.storeUserInfo(userInfo);
  }

  getUserInfo() {
    return this.userInfoService.getUserInfo();
  }

  getCachedCloudUser() {
    return this.cloudUserStorageService.currentUser;
  }

  getCachedUserInfo() {
    return this.userInfoStorageService.userInfo;
  }

  getCloudUser() {
    return this.cloudUserService.getCloudUser();
  }

  onChangeCloud() {
    this.userMessageService.changeMessage("");
    return this.navigateToClouds();
  }

  onResetPassword() {
    return this.resetPassword();
  }

  resetPassword() {
    return this.resetPasswordService.resetPassword();
  }

  navigateToClouds() {
    return this.router.navigateByUrl(this.cloudsUrl);
  }

  logout() {
    this.logoutService.logout();
  }

  onSignOff() {
    this.invalidateStoredTabSession();
    this.logout();
  }

  invalidateStoredTabSession() {
    return (this.tabSessionStorageService.tabSession = null);
  }

  getEmail() {
    return this.emailService.getEmail();
  }

  useLicense() {
    return this.callPeriodically(300000, () => this.getEmail()).pipe(
      takeWhile(() => this.alive)
    );
  }

  callPeriodically(period, func: () => Observable<any>) {
    return timer(0, period).pipe(
      mergeMap(() => {
        const now = this.now();
        const licenseCheckTime = this.loadLicenseCheckTime();
        const periodSeconds = period / 1000;
        const license_check_required_after = licenseCheckTime + periodSeconds;
        if (!licenseCheckTime || now > license_check_required_after) {
          this.storeLicenseCheckTime(now);
          return func();
        } else {
          return EMPTY;
        }
      })
    );
  }

  storeLicenseCheckTime(time) {
    localStorage.setItem(this.licenseCheckTimeStorageKey, time);
  }

  loadCloudId() {
    return this.cloudIdStorageService.loadCloudId();
  }

  now() {
    return this.timeService.now();
  }

  loadLicenseCheckTimeString() {
    return localStorage.getItem(this.licenseCheckTimeStorageKey);
  }

  loadLicenseCheckTime() {
    const licenseCheckString = this.loadLicenseCheckTimeString();
    if (licenseCheckString) {
      return Number.parseInt(licenseCheckString, 10);
    } else {
      return null;
    }
  }
}
